import { Minus } from 'lucide-react';
import { z } from 'zod';
import { DividerField } from '../renderers/fields/presentation/presentation-fields';
import type { DividerFieldSchema, FieldDefinition } from '../types';

export const DividerDefinition: FieldDefinition<DividerFieldSchema, void> = {
  type: 'divider',
  toolboxLabel: 'Divider Line',
  category: 'Presentation',
  description: 'A visual horizontal rule to separate form sections.',
  isPresentational: true,
  icon: Minus,

  createDefault: (id) => ({
    id,
    type: 'divider',
    name: `divider_${id}`,
    label: 'Divider',
    isPresentational: true,
  }),

  configSchema: [],

  buildValidation: () => z.any(),

  editComponent: DividerField,
  viewComponent: DividerField,
};
